var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8615_3373)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.941177,
    y: 0.941177,
    width: 5.64706,
    height: 5.64706,
    rx: 0.941177,
    stroke: "currentColor",
    strokeWidth: 1.88235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.941177,
    y: 10.3528,
    width: 5.64706,
    height: 5.64706,
    rx: 0.941177,
    stroke: "currentColor",
    strokeWidth: 1.88235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3528,
    y: 10.3528,
    width: 5.64706,
    height: 5.64706,
    rx: 0.941177,
    stroke: "currentColor",
    strokeWidth: 1.88235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3528,
    y: 0.941177,
    width: 5.64706,
    height: 5.64706,
    rx: 0.941177,
    stroke: "currentColor",
    strokeWidth: 1.88235
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8615_3373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9412,
    height: 16.9412,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.bf10840856a6efaecd93c4532b5ae9e1.svg";
export { ForwardRef as ReactComponent };